const POSTHOG_USER_KEY = "ph_identified_user_key";

function posthogInstance() {
  if (typeof window === "undefined") return null;
  return window.posthog || null;
}

function cleanProperties(values) {
  return Object.fromEntries(
    Object.entries(values).filter(([, value]) => value !== undefined && value !== null && value !== "")
  );
}

function userIdentityKey(user) {
  if (!user?.id) return "";
  return JSON.stringify({
    id: user.id,
    email: user.email,
    full_name: user.full_name,
    company: user.company,
    plan: user.plan,
    workspace_id: user.workspace_id,
    workspace_role: user.workspace_role,
    is_superadmin: user.is_superadmin === true,
    marketing_enabled: user.marketing_enabled === true,
    email_verified: user.email_verified !== false,
  });
}

export function identifyPostHogUser(user) {
  const posthog = posthogInstance();
  if (!posthog || !user?.id) return;

  const nextKey = userIdentityKey(user);
  if (window.sessionStorage?.getItem(POSTHOG_USER_KEY) === nextKey) return;

  const userProperties = cleanProperties({
    email: user.email,
    name: user.full_name,
    full_name: user.full_name,
    company: user.company,
    plan: user.plan || "starter",
    workspace_id: user.workspace_id || user.id,
    workspace_role: user.workspace_role || "member",
    is_superadmin: user.is_superadmin === true,
    marketing_enabled: user.marketing_enabled === true,
    email_verified: user.email_verified !== false,
  });

  const firstSeenProperties = cleanProperties({
    created_at: user.created_at,
    initial_plan: user.plan || "starter",
    initial_workspace_id: user.workspace_id || user.id,
  });

  posthog.identify(String(user.id), userProperties, firstSeenProperties);

  const workspaceId = user.workspace_id || user.id;
  if (workspaceId && typeof posthog.group === "function") {
    posthog.group("workspace", String(workspaceId), cleanProperties({
      name: user.company || user.full_name,
      plan: user.plan || "starter",
      owner_user_id: workspaceId,
    }));
  }

  window.sessionStorage?.setItem(POSTHOG_USER_KEY, nextKey);
}

export function resetPostHogIdentity() {
  const posthog = posthogInstance();
  if (typeof window !== "undefined") {
    window.sessionStorage?.removeItem(POSTHOG_USER_KEY);
  }
  if (!posthog || typeof posthog.reset !== "function") return;
  posthog.reset();
}

export function capturePostHogEvent(eventName, properties = {}) {
  const posthog = posthogInstance();
  if (!posthog || typeof posthog.capture !== "function" || !eventName) return;
  posthog.capture(eventName, cleanProperties(properties));
}
